import {useEffect, useState} from 'react'
import {useViewImageContext} from './ViewImageContext'
import {getImageCloudinessKey} from './imageCloudinessPreferences'

// Preferences live above the selectors so product/tab unmounts cannot reset
// them. Only the calendar's applied threshold is debounced, never the input.
export const useImageCloudinessFilter = (land, product) => {
  const {getImageCloudinessFilter, setImageCloudinessFilter} = useViewImageContext()
  const scope = getImageCloudinessKey(land, product)
  const cloudinessFilter = getImageCloudinessFilter(land, product)
  const [applied, setApplied] = useState(() => ({scope, value: cloudinessFilter}))
  const debouncedCloudinessFilter = applied.scope === scope ? applied.value : cloudinessFilter

  useEffect(() => {
    const timer = window.setTimeout(() => setApplied({scope, value: cloudinessFilter}), 800)
    return () => window.clearTimeout(timer)
  }, [scope, cloudinessFilter])

  return {
    cloudinessFilter,
    debouncedCloudinessFilter,
    isUpdatingCloudiness: cloudinessFilter !== debouncedCloudinessFilter,
    setCloudinessFilter: (value) => setImageCloudinessFilter(land, product, value),
  }
}
